import React from 'react';

const TokenaryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1365.333"
    height="1365.333"
    version="1"
    viewBox="0 0 1024 1024"
  >
    <path
      fill="#2C7CF5"
      d="M4850 8359c-278-23-576-90-850-191-888-329-1599-1040-1928-1928-129-350-188-660-199-1045-24-891 301-1725 920-2362 857-882 2121-1206 3302-848 370 112 772 327 1090 581 141 113 376 348 489 489 254 318 469 720 581 1090 133 438 175 913 120 1355-205 1650-1605 2881-3260 2869-93-1-213-5-265-10z"
      transform="matrix(.1 0 0 -.1 0 1024)"
    />
  </svg>
);

export default TokenaryIcon;
